import { render, staticRenderFns } from "./donation-error.vue?vue&type=template&id=ffdf1e46&scoped=true&lang=pug&"
import script from "./donation-error.vue?vue&type=script&lang=js&"
export * from "./donation-error.vue?vue&type=script&lang=js&"
import style0 from "./donation-error.vue?vue&type=style&index=0&id=ffdf1e46&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffdf1e46",
  null
  
)

export default component.exports